import AIPPortletsState from '../../state/cbo/AIPPortletsState';
import { AIPPortletsAction, AIPPortletsActionTypes } from '../../actions/cbo/AIPPortletsAction';
import { AIPPortletsModel, IConfigValidateResponse } from '../../../models/cbo/AIPPortletsModel';
import { AIPReportType } from '../../../../containers/CBOEngagementSummary/AIP/AIPPortletConstant';
import { AIPProjectReportModel, AIPReportActivitiesModel } from '../../../models/cbo/AIPDashboardReportModel';

const initialState: AIPPortletsState = {
  weeklyStatusReport: [],
  weeklyStatusReportLoading: false,
  minutesOfMeeting: [],
  minutesOfMeetingLoading: false,
  raidLog: [],
  raidLogLoading: false,
  projectStatusReport: [],
  projectStatusReportLoading: false,
  projectActivities: [],
  projectActivitiesLoading: false,
  configValidate: {} as IConfigValidateResponse,
  configValidateLoading: false,
  loading: false,
  error: null,
};

export const aipPortletsReducer = (
  state = initialState,
  action: AIPPortletsAction,
): AIPPortletsState => {
  switch (action.type) {
    case AIPPortletsActionTypes.GET_AIP_STARTED:
      return {
        ...state,
        weeklyStatusReport: [],
        minutesOfMeeting: [],
        raidLog: [],
        weeklyStatusReportLoading: true,
        minutesOfMeetingLoading: true,
        raidLogLoading: true,
        error: null,
      };
    case AIPPortletsActionTypes.GET_AIP_SUCCESS:
      const data = action.data as AIPPortletsModel[];
      if (data[0].outputType === AIPReportType.MinutesOfMeeting) {
        return {
          ...state,
          minutesOfMeetingLoading: false,
          minutesOfMeeting: data,
        };
      } else if (data[0].outputType === AIPReportType.WeeklyStatusReport) {
        return {
          ...state,
          weeklyStatusReportLoading: false,
          weeklyStatusReport: data,
        };
      } else if (data[0].outputType === AIPReportType.RaidLog) {
        return {
          ...state,
          raidLogLoading: false,
          raidLog: data,
        };
      } else {
        return state;
      }
    case AIPPortletsActionTypes.GET_AIP_ERROR:
      return {
        ...state,
        raidLogLoading: false,
        weeklyStatusReportLoading: false,
        minutesOfMeetingLoading: false,
        error: action.data as string,
      };
    case AIPPortletsActionTypes.GET_AIP_PROJECTS_STATUS_STARTED:
      return {
        ...state,
        projectStatusReport: [],
        projectStatusReportLoading: true,
        error: null,
      };
    case AIPPortletsActionTypes.GET_AIP_PROJECTS_STATUS_SUCCESS:
      const projectStatusData = action.data as AIPProjectReportModel[];
      return {
        ...state,
        projectStatusReportLoading: false,
        projectStatusReport: projectStatusData,
      };
    case AIPPortletsActionTypes.GET_AIP_PROJECTS_STATUS_ERROR:
      return {
        ...state,
        projectStatusReportLoading: false,
        error: action.data as string,
      };
    case AIPPortletsActionTypes.GET_AIP_PROJECTS_ACTIVITIES_STARTED:
      return {
        ...state,
        projectActivities: [],
        projectActivitiesLoading: true,
        error: null,
      };
    case AIPPortletsActionTypes.GET_AIP_PROJECTS_ACTIVITIES_SUCCESS:
      const projectActivitiesData = action.data as AIPReportActivitiesModel[];
      return {
        ...state,
        projectActivitiesLoading: false,
        projectActivities: projectActivitiesData,
      };
    case AIPPortletsActionTypes.GET_AIP_PROJECTS_ACTIVITIES_ERROR:
      return {
        ...state,
        projectActivitiesLoading: false,
        error: action.data as string,
      };
    case AIPPortletsActionTypes.GET_CONFIG_VALIDATE_STARTED:
      return {
        ...state,
        configValidate: {} as IConfigValidateResponse,
        configValidateLoading: true,
        error: null,
      };
    case AIPPortletsActionTypes.GET_CONFIG_VALIDATE_SUCCESS:
      const configData = action.data as IConfigValidateResponse;
      return {
        ...state,
        configValidateLoading: false,
        configValidate: configData,
      };
    case AIPPortletsActionTypes.GET_CONFIG_VALIDATE_ERROR:
      return {
        ...state,
        configValidateLoading: false,
        error: action.data as string,
      };
    default:
      return state;
  }
};
